import {
  maybeFormatNumberToNational,
  maybeGetPhoneUri,
} from '../../utils/phoneNumber';

interface Props {
  phoneNumber: string;
  className?: string;
}

export const PhoneNumberView: React.FC<Props> = ({
  phoneNumber,
  className,
}) => {
  const numberNational = maybeFormatNumberToNational(phoneNumber);
  const phoneUri = maybeGetPhoneUri(phoneNumber);
  const practicePhoneNumberLink =
    numberNational && phoneUri ? (
      <div className={className}>
        <a href={phoneUri}>{numberNational}</a>
      </div>
    ) : null;
  if (!practicePhoneNumberLink) return null;
  return practicePhoneNumberLink;
};
